import { memo, useState } from 'react';
import styled from '@emotion/styled';
import { Container, Stack, useTheme } from '@mui/material';
import { ForgotPasswordForm } from '../components/login/ForgotPasswordForm';
import { LoginForm } from '../components/login/LoginForm';

const LogoImg = styled.img`
  width: 30rem;
  max-width: 80vw;
  margin: 2rem 0 0 0;
`;

export const LoginPage = memo(function LoginPage() {
  const {
    assets: { logoURL },
  } = useTheme();
  const [forgotPasswordForm, setForgotPasswordForm] = useState(false);

  return (
    <Container
      component={Stack}
      maxWidth="sm"
      justifyContent="center"
      alignItems="center"
      gap={2}
    >
      <LogoImg src={logoURL} alt="logo" />

      {/* TODO: use react router to handle this */}
      {forgotPasswordForm ? (
        <ForgotPasswordForm
          onReturnToLogin={() => setForgotPasswordForm(false)}
        />
      ) : (
        <LoginForm onForgotPassword={() => setForgotPasswordForm(true)} />
      )}
    </Container>
  );
});
